var _require = require('../helper'),
  validLinkedinTrackingId = _require.validLinkedinTrackingId,
  getCookie = _require.getCookie;

exports.addLinkedin = function (options) {
  return new Promise(function (resolve, reject) {
    if (window.gatsbyPluginGDPRCookiesLinkedinAdded) return resolve(true);
    /* eslint-disable */
    // LINKED IN SPECIFIC CODE HERE

    _linkedin_partner_id = options.trackingId;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];

    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    /* eslint-enable */


    window.gatsbyPluginGDPRCookiesLinkedinAdded = true;
    resolve(true);
  });
};

exports.initializeLinkedin = function (options) {
  if (!window.gatsbyPluginGDPRCookiesLinkedinInitialized && getCookie(options.cookieName) === "true" && validLinkedinTrackingId(options)) {
    // (function(){
    var s = document.getElementsByTagName("script")[0];
    var b3 = document.createElement("script");
    b3.type = "text/javascript";
    b3.async = false;
    b3.innerHTML = ` (function(l) { if (!l){window.lintrk = function(a,b)

      {window.lintrk.q.push([a,b])}
      ; window.lintrk.q=[]}

    })(window.lintrk);
      `;
    if(options.nonce){
      b3.nonce = options.nonce;
    }

    var b2 = document.createElement("script");
    b2.type = "text/javascript";
    b2.async = false;
    b2.innerHTML = `_linkedin_partner_id = "${options.trackingId}";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `;

    if(options.nonce){
      b2.nonce = options.nonce;
    }

    var b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

    var b4 = document.createElement("noscript");
    var img = document.createElement('img');
    img.setAttribute('src', `https://px.ads.linkedin.com/collect/?pid=${options.trackingId}&fmt=gif`);
    img.setAttribute("height", "1");
    img.setAttribute("width", "1");
    img.setAttribute("style", "display:none;");
    img.setAttribute("alt", "");
    b4.appendChild(img);


    s.parentNode.insertBefore(b2, s);
    s.parentNode.insertBefore(b3, s);
    s.parentNode.insertBefore(b, s);
    s.parentNode.insertBefore(b4, s);
    // })();

    window.gatsbyPluginGDPRCookiesLinkedinInitialized = true;
  }
};